import { DataGridPro } from '@mui/x-data-grid-pro';

const renderDeclarations = (min = 1, max = 1) => {
  if (min && max) {
    return `${min} to ${max}`;
  }
  return `${min}+`;
};

const columns = [
  {
    field: 'tier',
    headerName: 'Tier',
    headerClassName: 'table-header',
    flex: 1,
    editable: false,
  },
  {
    field: 'declarationMin',
    headerName: 'Declarations',
    headerClassName: 'table-header',
    flex: 1,
    editable: false,
    renderCell: (params) => <>{renderDeclarations(params?.row?.declarationMin, params?.row?.declarationMax)}</>,
  },
  {
    field: 'priceGbp',
    headerName: 'Price (£)',
    headerClassName: 'table-header',
    flex: 1,
    editable: false,
    align: 'right',
    headerAlign: 'right',
    renderCell: (params) => <>{params?.row?.priceGbp?.toFixed(2)}</>,
  },
  {
    field: 'priceEur',
    headerName: 'Price (€)',
    headerClassName: 'table-header',
    flex: 1,
    editable: false,
    align: 'right',
    headerAlign: 'right',
    renderCell: (params) => <>{params?.row?.priceEur?.toFixed(2)}</>,
  },
];

const PricingTiersTable = ({ tiers }) => {
  return (
    <DataGridPro
      hideFooter
      rows={tiers}
      columns={columns}
      density="compact"
      disableColumnFilter
      disableColumnMenu
      disableColumnPinning
      disableColumnReorder
      disableColumnResize
      disableColumnSelector
      disableColumnSorting
      disableDensitySelector
      disableRowSelectionOnClick
      disableMultipleRowSelection
      rowSelection={false}
    />
  );
};

export default PricingTiersTable;
